import React from "react";
import AssetItem from "./AssetItem";

const AssetListManager = ({
  title,
  items = [],
  onDelete,
  onUpload,
  apiField,
  projectId,
  loading,
}) => {
  if (items.length === 0 && !loading) {
    return (
      <div className="mb-6">
        <h3 className="text-lg font-medium text-gray-800 mb-3 pb-2 border-b border-gray-200">
          {title}
        </h3>
        <div className="p-4 bg-gray-50 rounded-md text-gray-500 text-sm">
          No items available
        </div>
      </div>
    );
  }

  return (
    <div className="mb-6">
      <h3 className="text-lg font-medium text-gray-800 mb-3 pb-2 border-b border-gray-200">
        <span>{title}</span>
      </h3>

      <div className="flex flex-wrap gap-2">
        {items.map((item, index) => (
          <AssetItem
            key={index}
            item={item}
            projectId={projectId}
            onDelete={onDelete}
            onUpload={onUpload}
            apiField={apiField}
          />
        ))}
      </div>
    </div>
  );
};

export default AssetListManager;
